import React from "react";
import ResponsiveLayout from "../../common_components/ResponsiveLayout";
import HomeMobile from "./mobile/HomeMobile";
import HomeDesktop from "./desktop/HomeDesktop";

const Home = () => {
  return (
    <ResponsiveLayout
      MobileComponent={HomeMobile}
      DesktopComponent={HomeDesktop}
    />
  );
};

export default Home;